import { useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';
import { EnumLangs } from '@types';
import { getStorageItem } from 'helpers';
import { useAppSelector } from 'hooks';
import { Snackbar } from 'ui-kit';

import { ConfirmationModal } from 'components';

import i18n from './i18n';
import { MainRouter } from './router';
import { globalSel } from './store/global';

const App = () => {
    const { open: isSnackbarOpen } = useAppSelector(globalSel.snackbarSelector);
    const { open: isConfirmModalOpen } = useAppSelector(globalSel.confirmModalSelector);

    useEffect(() => {
        const lang = getStorageItem('lang') || EnumLangs.HY;

        i18n.changeLanguage(lang);
    }, []);

    return (
        <BrowserRouter>
            <MainRouter />
            {isSnackbarOpen ? <Snackbar /> : null}
            {isConfirmModalOpen ? <ConfirmationModal /> : null}
        </BrowserRouter>
    );
};

export default withTranslation()(App);
